// Application version shown in the About dialog.
// Bump this MANUALLY when cutting a release — it is intentionally NOT tied to the
// deploy image tags (vNNN) and is not auto-incremented during development.
export const APP_VERSION = '0.1.0';
